import { z } from "zod";
import { defineMutation } from "supabase/database/server.ts";

export const CreateData = defineMutation({
  input: z.object({
    table: z.string(),
    data: z.record(z.any(), z.any())
  }),
  handler: async ({ db }, { table, data }) => {
    const { data: result, error } = await db
      .from(table)
      .insert(data)
      .select();
    if (error) throw error;
    return result;
  },
});

export const UpdateData = defineMutation({
  input: z.object({
    table: z.string(),
    id: z.number(),
    data: z.record(z.any(), z.any())
  }),
  handler: async ({ db }, { table, id, data }) => {
    const { data: result, error } = await db
      .from(table)
      .update(data)
      .eq('id', id)
      .select();
    if (error) throw error;
    return result;
  },
});

export const DeleteData = defineMutation({
  input: z.object({
    table: z.string(),
    id: z.number()
  }),
  handler: async ({ db }, { table, id }) => {
    const { data: result, error } = await db
      .from(table)
      .delete()
      .eq('id', id)
      .select();
    if (error) throw error;
    return result;
  },
});